// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active{
    
    /* background: #4e73df; */
    /* background: #80bcdd; */
    background:#3a83f6;
    border-radius: 5px; 
    color: white;
    margin-left: 10px; 
    margin-right: 10px; 
    box-shadow: 0px 5px 8px rgba(255, 255, 255, 0.2);
    font-weight: bold;
}

@media (max-width: 790px){
    .smalltxt {
        font-size:9px;
        margin-left: -12px;
        display: block;
        
    }
    .svgheight {
        height:16px;
        display: block;
       
        
    }
}

/* .link{
    display: flex;
    color: black;
    padding: 8px 8px;
    gap: 15px;
    transition: all 0.5s;
} */

.link:hover{
    /* background:#8a898d; */
    color: #ffffff;
    margin-left: 20px; 
    margin-right: 20px; 
    border-radius: 8px; 
    transition: all 0.2s;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Components/navsidebar.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gDAAgD;IAChD,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;QAClB,cAAc;;IAElB;IAIA;QACI,WAAW;QACX,cAAc;;;IAGlB;AARJ;;AAWA;;;;;;GAMG;;AAEH;IACI,wBAAwB;IACxB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;AACzB","sourcesContent":[".active{\n    \n    /* background: #4e73df; */\n    /* background: #80bcdd; */\n    background:#3a83f6;\n    border-radius: 5px; \n    color: white;\n    margin-left: 10px; \n    margin-right: 10px; \n    box-shadow: 0px 5px 8px rgba(255, 255, 255, 0.2);\n    font-weight: bold;\n}\n\n@media (max-width: 790px){\n    .smalltxt {\n        font-size:9px;\n        margin-left: -12px;\n        display: block;\n        \n    }\n}\n\n@media (max-width: 790px){\n    .svgheight {\n        height:16px;\n        display: block;\n       \n        \n    }\n}\n\n/* .link{\n    display: flex;\n    color: black;\n    padding: 8px 8px;\n    gap: 15px;\n    transition: all 0.5s;\n} */\n\n.link:hover{\n    /* background:#8a898d; */\n    color: #ffffff;\n    margin-left: 20px; \n    margin-right: 20px; \n    border-radius: 8px; \n    transition: all 0.2s;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
